export default "__VITE_ASSET__2f557437__"